import React, { FC } from "react";
import { SVGProps } from '@utils';
import { SvgWrapper } from "./SvgWrapper";

export const BigArrowRight: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
      <path 
        d="M1.35088 18L0 16.7175L8.27412 9L0 1.2825L1.35088 0L11 9L1.35088 18Z" 
        fill="#3273E1" 
        fillOpacity="0.85" 
      />
    </svg>
  </SvgWrapper>
);